import store from '@/vue-instance/store';
import { LanguageChecker } from '@/services/localization/language-checker';

export const languageMiddleware = (to, from, next) => {
  store.dispatch('localization/setLanguage', LanguageChecker.getCorrectLanguage(to.params.language || store.getters['localization/getLanguage']));
};
